import { FormikErrors, FormikProps, FormikTouched } from "formik";
import React from "react";
import Auth0Login from "../pages/login/Auth0Login";
import { get } from "lodash";

export const deepTrim = (obj: any) => {
  if (obj) {
    Object.keys(obj).forEach((key) => {
      const valueType = typeof obj[key];
      if (valueType === "string") {
        try {
          obj[key] = obj[key].trim();
        } catch (err) {
          // ignore
        }
      } else if (valueType === "object") {
        deepTrim(obj[key]);
      }
    });
  }
  return obj;
};

export function hasTouchedErrors(
  props: FormikProps<any>,
  attributePath: string
) {
  const attributeNames = attributePath.split(".");
  // traverse through error and touched objects.
  let currentError = props.errors as FormikErrors<any> | undefined;
  let currentTouched = props.touched as FormikTouched<any> | undefined;
  attributeNames.forEach((attributeName: string) => {
    currentError = currentError
      ? (currentError[attributeName] as FormikErrors<any>)
      : undefined;
    currentTouched = currentTouched
      ? (currentTouched[attributeName] as FormikTouched<any>)
      : undefined;
  });
  if (currentError && currentTouched) {
    return currentError;
  }
  return null;
}
export function ActiveProvider(): "Auth0" {
  return "Auth0";
}
export const IS_DMG_INSTANCE = true;
export function cleanUpSessionStorage() {
  // No longer needed since we only use Auth0
}
const isEmptyArray = (arr) => {
  return Array.isArray(arr) && arr.length === 0;
}
const isEmptyObject = (obj) => {
  return obj && Object.keys(obj).length === 0;
}
const isNotEmptyArray = (arr) => {
  return Array.isArray(arr) && !isEmptyArray(arr)
}
const isNotEmptyObject = (obj) => {
  return !isEmptyObject(obj)
}
const arrayUnique = (arr) => {
  return arr.filter((item, index) => arr.indexOf(item) === index)
}
const isEmpty = (val) => {
  return val === '' || val === null || val === undefined;
}
const isNotEmpty = (val) => {
  return !isEmpty(val);
}
export const flat = (obj, currentKey = '', flatten = {}, exclude = []) => {
  const sep = '.'
  Object.keys(obj).forEach(key => {
    if (exclude.includes(key)) {

    } else if (obj[key] == null || ['number', 'string', 'undefined', 'boolean', 'symbol'].includes(typeof obj[key])) {
      const path = isNotEmpty(currentKey) ? `${currentKey}${sep}${key}` : key;
      flatten[path] = obj[key];
    } else if (isNotEmptyArray(obj[key])) {
      [].concat(obj[key]).forEach((childObject, index) => {
        const o = {};
        o[`[${index}]`] = childObject;
        flat(o, `${currentKey}${sep}${key}`, flatten, exclude)
      });
    } else if (isNotEmptyObject(obj[key])) {
      const path = isNotEmpty(currentKey) ? `${currentKey}${sep}${key}` : key;
      flat(obj[key], path, flatten, exclude)
    }
  })
  return flatten;
}
export const exportToVSC = (data, header:string[] = [], excludeFields:string[] = []) => {
  const headerScanned:string[] = [];
  data.forEach((record:any) => {
    // scan all record for headers
    Object.keys(flat(record.attributes,'root')).forEach(key=>{
      const column =  key.replace("root.","");
      if(!header.includes(column) && !headerScanned.includes(column) && excludeFields.every(field=>column.indexOf(field) !== 0)) {
        headerScanned.push(column);
      }
    });
  });
  headerScanned.sort();
  header.push(...headerScanned);
// export to csv file
  const rows = [
    header
  ]
  data.forEach((record:any) => {
    rows.push(header.map(column=>{
        const cell = get(record, column) ?? get(record.attributes, column) ?? "";
        return cell.toString().replace(/,/gi,' ')
        .replace(/\n/gi,' ')
        ;
    }))
  })
  let csvContent = "data:text/csv;charset=utf-8,"
    + rows.map(e => e.join(",")).join("\n");
  const encodedUri = encodeURI(csvContent);
  window.open(encodedUri);
}